import React, { Component } from 'react'

import loader from '../../style/loader.css'
class Loader extends Component {
    render() {
  
        return (
            <div className={loader.parentsh}>
                <div className={loader.spinnershlarge}>
                    </div>
                    <p className={loader.loadsh}>Loading...</p>
                    </div>
        )
      }
  
}
export default  Loader;
